/** Appends the `(Duplicated)` suffix to a name on fork. Returns null when
 *  the source had no name, so the catalog does not seed an unnamed row with
 *  a lone "(Duplicated)" string. One rule for actions, transfers, and any
 *  future duplicate flow. */
export function duplicatedName(sourceName) {
    const trimmed = sourceName?.trim();
    if (!trimmed)
        return null;
    return `${trimmed} (Duplicated)`;
}
//# sourceMappingURL=duplicate-name.js.map